"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "form-block-margin-top" };
const _hoisted_2 = {
    key: 0,
    class: "flex flex-wrap small-mt-top"
};
const DetailWideRadio_vue_1 = __importDefault(require("../../../components/frontend/DetailWideRadio.vue"));
const DetailSmallCheckbox_vue_1 = __importDefault(require("../../../components/frontend/DetailSmallCheckbox.vue"));
const bookAppointmentStore_1 = require("../../../stores/bookAppointment/bookAppointmentStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'TireDetails',
    setup(__props) {
        const bookAppointmentStore = (0, bookAppointmentStore_1.useBookAppointmentStore)();
        //console.log(bookAppointmentStore.reservedServiceLocationId);
        const changeIsWheel = (isWheel) => {
            bookAppointmentStore.tyreDatas.isWheel = isWheel;
            if (isWheel === false) {
                bookAppointmentStore.tyreDatas.isRunflat = false;
                bookAppointmentStore.tyreDatas.isTpms = false;
            }
        };
        const changeRunFlat = (e) => {
            bookAppointmentStore.tyreDatas.isRunflat = e.target.checked;
        };
        const changeTpms = (e) => {
            bookAppointmentStore.tyreDatas.isTpms = e.target.checked;
        };
        const changeStored = (e) => {
            bookAppointmentStore.tyreDatas.isStored = e.target.checked;
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(DetailWideRadio_vue_1.default, {
                    img: "felnivel.png",
                    name: "felni",
                    title: _ctx.$trans('with_rim', 'With rim', 'frontend_tyre_datas_block'),
                    text: _ctx.$trans('with_rim_text', 'The tyres are mounted on the rim and await retreading', 'frontend_tyre_datas_block'),
                    onChange: _cache[0] || (_cache[0] = ($event) => (changeIsWheel(true)))
                }, null, 8, ["title", "text"]),
                (0, vue_2.createVNode)(DetailWideRadio_vue_1.default, {
                    img: "felni_nelkul.png",
                    name: "felni",
                    title: _ctx.$trans('without_rim', 'Without rim', 'frontend_tyre_datas_block'),
                    text: _ctx.$trans('without_rim_text', 'Tyres will be mounted on rims in a service station', 'frontend_tyre_datas_block'),
                    onChange: _cache[1] || (_cache[1] = ($event) => (changeIsWheel(false)))
                }, null, 8, ["title", "text"]),
                ((0, vue_2.unref)(bookAppointmentStore).tyreDatas.isWheel !== null)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                        ((0, vue_2.unref)(bookAppointmentStore).tyreDatas.isWheel === false)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(DetailSmallCheckbox_vue_1.default, {
                                key: 0,
                                "input-name": "defektturo",
                                title: _ctx.$trans('runflat', 'Runflat', 'frontend_tyre_datas_block'),
                                text: _ctx.$trans('runflat_text', 'If your tyre is runflat, mark it for special treatment.', 'frontend_tyre_datas_block'),
                                onChange: changeRunFlat
                            }, null, 8, ["title", "text"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((0, vue_2.unref)(bookAppointmentStore).tyreDatas.isWheel === false)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(DetailSmallCheckbox_vue_1.default, {
                                key: 1,
                                class: "ml-auto mr-auto",
                                "input-name": "tpms",
                                title: _ctx.$trans('tpms', 'TPMS', 'frontend_tyre_datas_block'),
                                text: _ctx.$trans('tpms_text', 'If your tyre has TPMS, tick the box.', 'frontend_tyre_datas_block'),
                                onChange: changeTpms
                            }, null, 8, ["title", "text"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createVNode)(DetailSmallCheckbox_vue_1.default, {
                            "input-name": "tarolt_abroncs",
                            title: _ctx.$trans('stored_tyre', 'Stored tyre', 'frontend_tyre_datas_block'),
                            text: _ctx.$trans('stored_tyre_text', 'If your tyre is in storage, mark it for special treatment.', 'frontend_tyre_datas_block'),
                            onChange: changeStored
                        }, null, 8, ["title", "text"])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
